/**
 *
 */
// Scroll Position
$(window).scroll(function () {
  const topY = 70;
  let posY = $(this).scrollTop();
  //console.log(posY);

  if (posY >= topY) {
    //$(".header-white, .header-black").css(
    //  "box-shadow",
    //  "0 1px 1px rgba(0, 0, 0, 0.2)"
    //);
  } else if (posY < topY) {
    $(".header-white, .header-black").css("box-shadow", "none");
  }
});

/**
 * ScrollReveal
 */
ScrollReveal().reveal(".sr-box", {
  // Exspand
  //duration: 500,
  //scale: 3,
  //reset: true,

  // TOP
  duration: 600,
  origin: "bottom",
  distance: "60px",
  reset: true,

  //
  //duration: 800, // アニメーションの完了にかかる時間
  //viewFactor: 0.2, // 0~1,どれくらい見えたら実行するか
  //reset: true, // 何回もアニメーション表示するか
});

/**
 * Wsmenus
 */
const Wsmenus = {
  respmenu: false,
  mid: null,
  mode: "",

  type: function (type) {
    Wsmenus.mode = type ? "-black" : " ";
  },

  on: function (id, type) {
    Wsmenus.type(type);

    $(".ws-submenu" + Wsmenus.mode).removeClass("ws-submenu-open");
    $("#ws-menu-id-" + Wsmenus.mid).removeClass("ws-menu-bar" + Wsmenus.mode);
    $("#ws-menu-id-" + Wsmenus.mid).removeClass("ws-menu-arrow" + Wsmenus.mode);
    $("#ws-submenu-pid-" + Wsmenus.mid + ".ws-submenu" + Wsmenus.mode).css(
      "top",
      "-80px"
    );

    let sublen = $("#ws-submenu-pid-" + id + " li").length;
    if (sublen) {
      $("#ws-submenu-pid-" + id + ".ws-submenu" + Wsmenus.mode).css(
        "top",
        "80px"
      );
      $("#ws-submenu-pid-" + id).addClass("ws-submenu-open");

      $("#ws-menu-id-" + id).addClass("ws-menu-arrow" + Wsmenus.mode);
    } else {
      $("#ws-menu-id-" + id).addClass("ws-menu-bar" + Wsmenus.mode);
    }

    Wsmenus.mid = id;
  },
  off: function (id, type) {
    Wsmenus.type(type);

    $(".ws-submenu" + Wsmenus.mode).removeClass("ws-submenu-open");
    $("#ws-menu-id-" + Wsmenus.mid).removeClass("ws-menu-bar" + Wsmenus.mode);
    $("#ws-menu-id-" + Wsmenus.mid).removeClass("ws-menu-arrow" + Wsmenus.mode);
    $("#ws-submenu-pid-" + Wsmenus.mid + ".ws-submenu" + Wsmenus.mode).css(
      "top",
      "-80px"
    );
  },
  resp_onoff: function () {
    if (!Wsmenus.respmenu) {
      $("#ws-menu-responsive").css("opacity", "0.98");
      $("#ws-menu-responsive").css("right", "0");
      $("#ws-menu-responsive").on(
        "transitionend webkitTransitionEnd",
        function () {
          Wsmenus.respmenu = true;
        }
      );
    } else {
      $("#ws-menu-responsive").css("opacity", "0");
      $("#ws-menu-responsive").css("right", "-100%");
      $("#ws-menu-responsive").on(
        "transitionend webkitTransitionEnd",
        function () {
          Wsmenus.respmenu = false;
        }
      );
    }
  },
};

/**
 * Events
 */
$(window).on("load", function () {
  $(".ws-resp-btn").on("click", function () {
    Wsmenus.resp_onoff();
  });

  // Links
  $(".ws-cover-image__top-it").on("click", function () {
    location.href = "/it";
  });
  $(".ws-cover-image__top-sponsorship").on("click", function () {
    location.href = "/sponsorship";
  });
});
